// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.9.0';
export const APP_NAME = 'prada-coupon';
export const FILE_HASH = '1584011059030';
export const BUILD_DATE = '2020-03-12T11:04:19.030Z';
/* tslint:enable */
